import styles from "./Range.module.scss";
import { Controller } from "react-hook-form";
import type {
  Control,
  FieldValues,
  RegisterOptions,
  UseFormRegisterReturn,
} from "react-hook-form";
import withLabelAndError from "../withLabelAndError";

export interface RangeProps<TFieldValues extends FieldValues = FieldValues> {
  control?: Control<TFieldValues>;
  register?: (name: string, options?: RegisterOptions<TFieldValues>) => UseFormRegisterReturn;
  validations?: RegisterOptions<TFieldValues>;
  name: string;
  placeholder?: string;
  min: number;
  max: number;
  [key: string]: unknown;
}

const Range = <TFieldValues extends FieldValues = FieldValues>({
  control,
  register,
  validations,
  name,
  placeholder,
  ...rest
}: RangeProps<TFieldValues>) => {
  const { min, max } = rest as { min: number; max: number };

  const renderRange = (field: Partial<UseFormRegisterReturn> = {}) => (
    <div className={styles.rangeInput}>
      <input
        {...field}
        {...rest}
        id={name}
        type="range"
        className={styles.inputField}
        placeholder={placeholder}
      />
      <div className={styles.rangeLabel}>
        {Array.from({ length: max - min + 1 }, (_, i) => min + i).map((num) => (
          <button
            key={num}
            type="button"
            onClick={() => {
              field.onChange?.({ target: { value: num, name } });
            }}
          >
            {num}
          </button>
        ))}
      </div>
    </div>
  );

  if (control) {
    return (
      <Controller
        control={control}
        {...(validations ? { rules: validations } : {})}
        name={name as never}
        render={({ field }) => renderRange(field as unknown as Partial<UseFormRegisterReturn>)}
      />
    );
  } else {
    const field = register ? register(name, validations) : {};
    return renderRange(field);
  }
};

const RangeWithLabelAndError = withLabelAndError(Range);

export default RangeWithLabelAndError;
export { Range };
